__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "naviance-student-connection";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ps-refarch-ux/mfe-utils", "2.3.100", () => (__webpack_require__.e(88).then(() => (() => (__webpack_require__(2088))))));
			register("@ps-refarch-ux/neon", "2.5.0", () => (Promise.all([__webpack_require__.e(155), __webpack_require__.e(536)]).then(() => (() => (__webpack_require__(6155))))));
			register("@tanstack/react-query", "5.25.0", () => (__webpack_require__.e(84).then(() => (() => (__webpack_require__(5084))))));
			register("axios", "1.6.8", () => (__webpack_require__.e(418).then(() => (() => (__webpack_require__(9418))))));
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(961))), 1);
			register("react-router-dom", "6.11.1", () => (__webpack_require__.e(648).then(() => (() => (__webpack_require__(2648))))));
			register("react", "18.2.0", () => (() => (__webpack_require__(6540))), 1);
			register("uuid", "9.0.1", () => (__webpack_require__.e(308).then(() => (() => (__webpack_require__(9308))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};